import _ from 'lodash';
import axios from 'axios';
import qs from 'qs';

export const tracking = (url = '', params = {}) =>
  axios
    .get(`${url}&${qs.stringify(params)}`)
    .then(data => data)
    .catch(error => {
      const data = _.get(error, 'response.data', false);
      if (data) return data;
      return error;
    });
